import type { PostHogConfig } from "posthog-js";

export const getPostHogConfig = (
  apiUrl: string,
  posthogPublicHost: string,
): Partial<PostHogConfig> => ({
  api_host: posthogPublicHost,
  __add_tracing_headers: [new URL(apiUrl).hostname],
  session_recording: {
    maskAllInputs: false,
    maskInputOptions: {
      password: true,
    },
  },
});
